enum AppEnvironment {
  BRAND = 'BRAND',
  STORE = 'STORE',
}

export default AppEnvironment;
